import React from "react";
import CustomModal from "../CustomModal";
import { motion, AnimatePresence } from "framer-motion";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./FilterModal.css";

const FilterModal = ({
  open,
  onClose,
  filters,
  setFilters,
  onApplyFilters,
}) => {
  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Refine Your Search"
      showCloseButton={true}
      actions={[
        {
          label: "Apply Filters",
          onClick: onApplyFilters,
          color: "primary",
          variant: "contained",
          sx: {
            borderRadius: 25,
            px: 2,
            py: 0.75,
            fontSize: "0.9rem",
            "&:hover": {
              transform: "translateY(-1px)",
              bgcolor: "primary.dark",
            },
          },
        },
      ]}
    >
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "100%", opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="filters">
              <select
                value={filters.priceOrder}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    priceOrder: e.target.value,
                  }))
                }
              >
                <option value="asc">Price: Low to High</option>
                <option value="desc">Price: High to Low</option>
              </select>

              <select
                value={filters.kitchenCategory}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    kitchenCategory: e.target.value,
                  }))
                }
              >
                <option value="">Kitchen Category</option>
                <option value="commercial">Commercial Kitchen</option>
                <option value="restaurant">Restaurant Kitchen</option>
                <option value="ghost">Ghost Kitchen</option>
                <option value="bakery">Bakery Kitchen</option>
                <option value="private">Private Kitchen</option>
                <option value="all">All Purpose Kitchen</option>
              </select>

              <select
                value={filters.bookingType}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    bookingType: e.target.value,
                  }))
                }
              >
                <option value="">Booking Type</option>
                <option value="hour">Hourly</option>
                <option value="day">Daily</option>
              </select>

              <div className="date-time-filters">
                <label>Check-in Date</label>
                <DatePicker
                  selected={filters.checkinDate}
                  onChange={(date) =>
                    setFilters((prev) => ({ ...prev, checkinDate: date }))
                  }
                  dateFormat="MM/dd/yyyy"
                  placeholderText="Select Check-In Date"
                  className="date-picker-input"
                />
                <label>Check-out Date</label>
                <DatePicker
                  selected={filters.checkoutDate}
                  onChange={(date) =>
                    setFilters((prev) => ({ ...prev, checkoutDate: date }))
                  }
                  dateFormat="MM/dd/yyyy"
                  placeholderText="Select Check-Out Date"
                  className="date-picker-input"
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </CustomModal>
  );
};

export default FilterModal;
